import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import style from './RadioToggle.less'

class RadioToggle extends Component {
    static propTypes = {
        value: PropTypes.any,
        onChange: PropTypes.func.isRequired
    }

    _toggle(item) {
        const {value, onChange} = this.props
        
        var nextValue = item != value && item || null
        onChange(nextValue)
    }

    _isChecked(item) {
        const {value} = this.props
        return item == value
    }

    _enhance(children) {
        return React.Children.map(children, (child) => {
            if (child && child.type && (child.type == 'input' || child.type.displayName == 'Input')) {
                const {value} = child.props

                return React.cloneElement(child, {
                    checked: this._isChecked(value),
                    onChange: () => this._toggle(value)
                })
            }
            if (child && child.props) {
                const {children} = child.props

                return children && React.cloneElement(child, {
                    children: this._enhance(children)
                }) || child
            }
            return child
        })
    }

    render() {
        const {children, bsStyle, value, onChange} = this.props

        return (
            <div className={cx(style.default, {[style.error]: bsStyle == 'error'})}>
                {this._enhance(children)}
            </div>
        )
    }
}

export default RadioToggle


// WEBPACK FOOTER //
// ./lib/core/components/RadioToggle.js